export default "__VITE_ASSET__zJUwt4J4__"